export function generateCustomizeString(String) {
  return this.$t('customize.' + String)
}
